// extracted by mini-css-extract-plugin
export default {"headerBar":"ZI-z","pointsSection":"_I-z","goToDashboard":"aJ-z"};